import React, { useState } from "react";
import "./CSS/SaleSidebar.css";
import { useHistory } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";

const label = { inputProps: { "aria-label": "Switch demo" } };

const SaleSidebar = ({ params, setParams }) => {
  const history = useHistory();
  const [nearby, setNearby] = useState("Just My neighborhood");

  console.log(params);

  const categoryList = [
    { name: "AI Agents & Automation" },
    { name: "Generative AI & Content Creation" },
    { name: "Natural Language Processing" },
    { name: "Computer Vision" },
    { name: "LLMOps & Model Management" },
    { name: "AI Infrastructure & GPU" },
    { name: "Predictive Analytics" },
    { name: "Business Intelligence & Data Visualization" },
    { name: "Chatbots & Virtual Assistants" },
    { name: "Recommendation Systems" },
    { name: "Fraud Detection & Security" },
    { name: "Healthcare AI" },
    { name: "Financial AI" },
    { name: "Marketing & Sales AI" },
    { name: "HR & Talent Management" },
    { name: "Edge AI & IoT" },
    { name: "Data Processing & ETL" },
    { name: "AI Development Tools" },
    { name: "Sentiment Analysis & Text Mining" },
    { name: "Other" },
  ];

  return (
    <div className="sale_page_sidebar_parent">
      <p
        className="sale_page_sidebar_gohome"
        style={{ display: "flex", gap: "5px", alignItems: "center" }}
        onClick={() => {
          history.push({ pathname: "/user" });
        }}
      >
        <svg
          width="30px"
          height="30px"
          viewBox="0 0 1024 1024"
          fill="#000000"
          class="icon"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M669.6 849.6c8.8 8 22.4 7.2 30.4-1.6s7.2-22.4-1.6-30.4l-309.6-280c-8-7.2-8-17.6 0-24.8l309.6-270.4c8.8-8 9.6-21.6 2.4-30.4-8-8.8-21.6-9.6-30.4-2.4L360.8 480.8c-27.2 24-28 64-0.8 88.8l309.6 280z"
            fill=""
          />
        </svg>
        <span>Home</span>
      </p>
      <div>
        <p
          className="sale_page_sidebar_list_title"
          style={{ marginTop: "10px" }}
        >
          Filters
        </p>
        <ul className="sale_page_sidebar_ul">
          <li
            onClick={() =>
              setParams((prev) => {
                const { freeData, ...rest } = prev;
                return rest;
              })
            }
            className="sale_page_sidebar_li"
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            {params?.freeData === undefined && <DoneIcon fontSize="small" />}
            <span
              style={{ fontWeight: params?.freeData === undefined ? 600 : 400 }}
            >
              All Deals
            </span>
          </li>
          <li
            onClick={() => setParams((prev) => ({ ...prev, freeData: true }))}
            style={{
              fontWeight: params?.freeData === true ? 600 : 400,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
            className="sale_page_sidebar_li"
          >
            {params?.freeData === true && <DoneIcon fontSize="small" />}
            Free
          </li>
          <li
            onClick={() => setParams((prev) => ({ ...prev, freeData: false }))}
            style={{
              fontWeight: params?.freeData === false ? 600 : 400,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
            className="sale_page_sidebar_li"
          >
            {params?.freeData === false && <DoneIcon fontSize="small" />}
            Paid
          </li>
        </ul>
      </div>
      <div>
        <p className="sale_page_sidebar_list_title">Sort By</p>
        <ul className="sale_page_sidebar_ul">
          <li
            onClick={() =>
              setParams((prev) => {
                const { newest, ...rest } = prev;
                return rest;
              })
            }
            className="sale_page_sidebar_li"
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            {!params?.newest && <DoneIcon fontSize="small" />}
            <span style={{ fontWeight: !params?.newest ? 600 : 400 }}>
              Most Relevant
            </span>
          </li>
          <li
            onClick={() => setParams((prev) => ({ ...prev, newest: true }))}
            style={{
              fontWeight: params?.newest ? 600 : 400,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
            className="sale_page_sidebar_li"
          >
            {params?.newest && <DoneIcon fontSize="small" />}
            Newest
          </li>
        </ul>
      </div>
      <div>
        <p className="sale_page_sidebar_list_title">Show items from</p>
        <ul className="sale_page_sidebar_ul">
          <li
            onClick={() => setNearby("Just My neighborhood")}
            className="sale_page_sidebar_li"
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            {nearby === "Just My neighborhood" && <DoneIcon fontSize="small" />}
            <span
              style={{
                fontWeight: nearby === "Just My neighborhood" ? 600 : 400,
              }}
            >
              Just My neighborhood
            </span>
          </li>
          <li
            onClick={() => setNearby("Nearby neighborhoods")}
            className="sale_page_sidebar_li"
            style={{
              fontWeight: nearby === "Nearby neighborhoods" ? 600 : 400,
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            {nearby === "Nearby neighborhoods" && <DoneIcon fontSize="small" />}
            Nearby neighborhoods
          </li>
        </ul>
      </div>
      <div>
        <p className="sale_page_sidebar_list_title">Categories</p>
        <ul className="sale_page_sidebar_ul">
          <li
            onClick={() =>
              setParams((prev) => {
                const { sell_type, ...rest } = prev;
                return rest;
              })
            }
            className="sale_page_sidebar_li"
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            {!params?.sell_type && <DoneIcon fontSize="small" />}
            <span style={{ fontWeight: !params?.sell_type ? 600 : 400 }}>
              All Categories
            </span>
          </li>

          {categoryList?.map((item, index) => (
            <li
              onClick={() =>
                setParams((prev) => ({ ...prev, sell_type: item.name }))
              }
              key={index}
              className="sale_page_sidebar_li"
              style={{
                fontWeight: params?.sell_type === item.name ? 600 : 400,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              {params?.sell_type === item.name && <DoneIcon fontSize="small" />}
              {item?.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SaleSidebar;
